<template>
    <div :class="$attrs.class">
        <label :for="id" class="form-label">{{label}}</label>
        <select :id="id" v-model="selected" v-bind="{ ...$attrs, class: null }" class="form-input" :class="{ error: error }" >
            <slot />
        </select>
        <div v-if="error" class="form-error">{{ error }}</div>
        <div v-if="custError" class="mt-2 text-red-500 h-8">{{ custError }}</div>
    </div>
</template>


<script>
export default{
    inheritAttrs: false,
    props: {
        id: String,
        error: String,
        custError: String,
        type: {
            type: String,
            default: 'text'
        },
        label: String,
        modelValue: String
    },
    emits: ['update:modelValue'],
    data(){
        return {
            selected: this.modelValue
        }
    },
    watch: {
        selected(selected){
            this.$emit('update:modelValue',selected)
        }
    }
}
</script>